import { MessageSquare, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const detectCompetitorEvaluationCompetitiveWinCampaignAr: TemplateAr = {
  name: 'رصد تقييم المنافسين + حملة فوز تنافسية',
  description:
    'الذكاء الاصطناعي يرصد العملاء المحتملين اللي يقارنون البدائل ويُطلق مواد ومكالمات مبيعات تنافسية.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: MessageSquare, label: 'ذكر منافس' },
    { icon: Sparkles, label: 'الـ AI يرصد' },
    { icon: Phone, label: 'عرض تنافسي', final: true },
  ],
  detailDescription: {
    paragraph1:
      'لمّا يقارنك العميل بمنافس، تعرف وقتها، وتطلق حملة فوز موجّهة. الـ AI يعرف ذكر أسماء المنافسين، وطلبات المقارنة، وجداول التقييم، وإشارات القرار. ويرسل أدلة المقارنة التنافسية ودراسات الحالة تلقائياً، ويطلق مكالمة مبيعات ونقاط التموضع التنافسي جاهزة فيها من البداية.',
    paragraph2:
      'الـ AI يكتب إشارات التقييم التنافسي ونتائج الحملات في الـ CRM وأدوات ذكاء المبيعات عندك. ويبني ذكاءً تنافسياً من بيانات الفوز والخسارة، ويحسّن رسائلك التنافسية باستمرار. ومندوبك يجيه تنبيه لحظي كل ما قيّم عميل محتمل بديلاً ثانياً.',
  },
  benefits: [
    'اكسب الصفقة التنافسية قبل ما يقرر العميل',
    'تحرّك في لحظة القرار نفسها',
    'مندوبك يدخل بذكاء تنافسي جاهز',
    'تمنع الخسارة لصالح المنافسين',
    'تشوف معدل فوزك التنافسي',
    'التموضع التنافسي يتحسّن تلقائياً',
  ],
};
